import { render, staticRenderFns } from "./lisaa-arvioitava-kokonaisuus.vue?vue&type=template&id=cc434152&scoped=true&"
import script from "./lisaa-arvioitava-kokonaisuus.vue?vue&type=script&lang=ts&"
export * from "./lisaa-arvioitava-kokonaisuus.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-arvioitava-kokonaisuus.vue?vue&type=style&index=0&id=cc434152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc434152",
  null
  
)

export default component.exports